import { particles } from 'app/contracts/Particles';
import { geometry } from 'app/contracts/Geometry';

export class MouseTarget implements particles.ParticleTarget {
	private _sceneProps: particles.SceneProps;

	private _targetContainer: string = null;

	constructor(targetContainer: string = null) {
		this._targetContainer = targetContainer;
	}

	public get position(): geometry.Vector2 {
		if (this._targetContainer) {
			return {
				x: this._sceneProps.mouse.cords.x - this._sceneProps.mouse.particleContainersX[this._targetContainer],
				y: this._sceneProps.mouse.cords.y - this._sceneProps.mouse.particleContainersY[this._targetContainer]
			};
		}

		return this._sceneProps.mouse.cords;
	}

	public set targetContainer(c: string) {
		this._targetContainer = c;
	}

	public set sceneProps(v: particles.SceneProps) {
		this._sceneProps = v;
	}

	public get relativePosition(): geometry.Vector2 {
		return this._sceneProps.mouse.scene;
	}
}
